/*
 *
 * OperationDCC
 *
 * @version 1.0.0
 * @author Christopher Monti
 * @since 10-Mar-2025
 */

import OperationDCC from './OperationDCCContainer'

export default OperationDCC
